import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { isAuthenticated, logout, verificaSessioneServer } from '../services/otpAuthService';

/**
 * Wrapper di gating per le route dell'area associati (`/area-riservata/*`).
 *
 * Due controlli:
 *  1. LOCALE, sincrono: `isAuthenticated()` legge il token in `localStorage.associate_token`
 *     (presenza + scadenza dal payload). Assente o scaduto → redirect a `/accesso-associati`,
 *     preservando l'URL originale come `state.from` per il redirect post-login.
 *  2. LATO SERVER, una volta per montaggio: `verificaSessioneServer()` chiede a `/auth/me`
 *     se il token vale ancora. Serve perche' il controllo locale non vede una FIRMA non piu'
 *     valida: il 29/08/2026, con la rotazione di JWT_SECRET sul VPS, tutti i token emessi
 *     prima sono diventati «invalid signature» — il sito sembrava loggato, ogni API dava
 *     401 e l'estensione Takata (che riceve lo stesso token dal sito) diceva «Accedi
 *     all'area riservata» a chi c'era gia' dentro. Si usciva solo con logout + login.
 *     Qui, se il server RIFIUTA il token, si fa logout e si va alla pagina di accesso;
 *     se non risponde o e' in errore (esito indeterminato) non si tocca nulla.
 *
 * La pagina si renderizza subito (nessuna attesa della verifica): in caso di rifiuto il
 * redirect arriva un attimo dopo, e le chiamate della pagina avrebbero comunque fallito.
 *
 * Fix B13 (Round 2 Wave A): prima le route /area-riservata* erano definite senza alcun
 * wrapper di autenticazione lato client. La sicurezza vera resta sul backend (token JWT
 * verificato server-side); questo wrapper e' difesa in profondita' + UX.
 */
const AssociatePrivateRoute: React.FC = () => {
  const location = useLocation();
  const [sessioneRifiutata, setSessioneRifiutata] = useState(false);

  useEffect(() => {
    if (!isAuthenticated()) return undefined;
    let attivo = true;
    verificaSessioneServer().then((esito) => {
      if (!attivo || esito !== 'rifiutata') return;
      logout();
      setSessioneRifiutata(true);
    });
    return () => { attivo = false; };
  }, []);

  if (!isAuthenticated() || sessioneRifiutata) {
    return (
      <Navigate
        to="/accesso-associati"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  return <Outlet />;
};

export default AssociatePrivateRoute;
